module.exports = __webpack_public_path__ + "img/mongolia.67d8b46.webp";